import ClassNames from "classnames";
import { FunctionComponent } from "react";
import styles from "../stylesheets/components/language-menu-list.module.css";
import { LanguageMenuItem } from "../types/index.js";
import SmartLink from "./SmartLink.js";

interface Props {
  items: LanguageMenuItem[];
  isPreview: boolean;
  className: string;
  itemClassName: string;
}

const LanguageMenuList: FunctionComponent<Props> = ({
  items,
  isPreview,
  className,
  itemClassName,
}) => (
  <ul className={ClassNames(styles.LanguageMenu__List, className)}>
    {items.map(({ children, href, hrefLang, rel }) => (
      <li className={ClassNames(itemClassName)} key={hrefLang}>
        <SmartLink
          isPreview={isPreview}
          anchorAttrs={{
            rel,
            hrefLang,
            href,
            className: styles.LanguageMenu__Item,
          }}
        >
          {children}
        </SmartLink>
      </li>
    ))}
  </ul>
);

export default LanguageMenuList;
